import { useEffect } from 'react'
import useGlobalStore from '@/store/useGlobalStore'
import { useRouter } from 'next/router'
import { withServerSideTranslations } from '@/lib/hoc/withServerSideTranslations'
import useClientRedirect from '@/lib/hooks/routing/useRedirect'
import { useInitTranslations } from '@/lib/hooks/initializers/useInitTranslations'
import type { InferGetServerSidePropsType } from 'next'

export const getServerSideProps = withServerSideTranslations()

const ReferralPage = ({
  translations,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  useInitTranslations({ translations })

  const router = useRouter()
  const { clientRedirect } = useClientRedirect()

  const {
    setUser,
    user: { isSignedIn },
  } = useGlobalStore()

  useEffect(() => {
    if (!router.query.referralCode) return

    // Once the user is signed in, we don't need to add referrals
    // This avoids changing their customer type back to customer,
    // which would show incorrect pricing if they're logged in
    if (isSignedIn) return
    ;(async () => {
      // We need to set the customer type and the refName back to defaults to force the customer call to fetch ref data
      // Otherwise the user could be referred two times, but the second time would not work bc the first ref is cached
      setUser({
        refID: router.query.referralCode as string,
        refName: null,
        customerType: 'Customer',
      })

      await clientRedirect.to({ path: '/products' })
    })().catch(() => {})
  }, [router.query.referralCode, setUser, isSignedIn])
}

export default ReferralPage
